export const LEGAL_NAME = 'Mevoly Hair';

export const LEGAL_EMAIL = 'mevolyhair.care@gmail.com';

export const PRIVACY_EMAIL = 'mevolyhair.care@gmail.com';

export const LEGAL_PHONE = '+234 703 505 3305';

export const LEGAL_PHONE_ALT = '+234 703 505 3305';

export const LEGAL_ADDRESS = '1A, Vanni Estate, Dipo Abe street, Ojodu Berger';

export const GOVERNING_LAW = 'Federal Republic of Nigeria';

export const DISPUTE_VENUE = 'Lagos State, Nigeria';

export const LAST_UPDATED = 'June 2026';

export const LIABILITY_CAP_MONTHS = 3;

export type LegalSection = {
  title: string;
  content: string[];
};
